module.exports = __webpack_public_path__ + "static/26-e5ce103ac461c026b5bc5f3521a1a44d.jpg";